import { Directive, ElementRef, Input, OnChanges, inject } from '@angular/core';
import * as d3 from 'd3';

@Directive({
  selector: '[bshLegend]',
})
export class LegendDirective implements OnChanges {
  #el = inject(ElementRef<SVGElement>);
  @Input() subgroups: readonly string[] = [];
  @Input() colors: readonly string[] = [];
  @Input() spacing = 24;
  @Input() visible = true;
  @Input() legendX = 0;
  @Input() legendY = 0;
  @Input() legendWidth = 120;

  ngOnChanges(): void {
    this.renderLegend();
  }

  private renderLegend() {
    const g = d3.select(this.#el.nativeElement);
    g.selectAll('*').remove();

    if (!this.visible) return;

    const legendGroup = g
      .append('g')
      .attr('width', this.legendWidth)
      .attr('transform', `translate(${this.legendX},${this.legendY})`);

    this.subgroups.forEach((key, i) => {
      const legendItem = legendGroup
        .append('g')
        .attr('transform', `translate(0,${i * this.spacing})`);

      legendItem
        .append('rect')
        .attr('width', 18)
        .attr('height', 18)
        .attr('fill', this.colors[i % this.colors.length])
        .attr('stroke', '#ccc')
        .attr('rx', 3);

      legendItem
        .append('text')
        .attr('x', 26)
        .attr('y', 14)
        .attr('font-size', 14)
        .attr('fill', '#333')
        .text(key);
    });
  }
}
